



























import Vue from 'vue';

import Version  from '@/components/version.vue'
import Love     from '@/components/made-with-love.vue';
import Terms    from '@/components/terms.vue';

export default Vue.extend({
    data() {
        return {
            tweetText: 'Check out quizMe - free online flashcards...with automatic reminders and scientifically proven memorization techniques! https://getquizme.com #learnsimplyanything'
        }
    },
    computed: {
        urlTweetText() {
            return encodeURI(this.tweetText)
        }
    },
    components: {
        version: Version,
        'made-with-love': Love,
        Terms
    },
});
